<div class="header">
    @if (envName !== '') {
        <div class="ribbon ribbon-top-left">
            <span [ngClass]="{
                    'bg-local': envName === 'local',
                    'bg-dev': envName === 'dev',
                    'bg-qa': envName === 'QA'}">
                {{ envName }}
            </span>
        </div>
    }

    @if (activeBanner) {
        <a class="alert information-banner"
           [ngClass]="{
                'alert-primary': activeBanner.bannerInformationLevel === BannerInformationLevelDto.Information,
                'alert-warning': activeBanner.bannerInformationLevel === BannerInformationLevelDto.Warning,
                'alert-danger': activeBanner.bannerInformationLevel === BannerInformationLevelDto.Incident
            }"
           [routerLink]="['/communication-channel/information', activeBanner.id]">

            @switch (activeBanner.bannerInformationLevel) {
                @case (BannerInformationLevelDto.Information) {
                    <fa-icon
                        class="me-2"
                        [icon]="icons.info">
                    </fa-icon>
                }
                @case (BannerInformationLevelDto.Warning) {
                    <fa-icon
                        class="me-2"
                        [icon]="icons.warning">
                    </fa-icon>
                }
                @case (BannerInformationLevelDto.Incident) {
                    <fa-icon
                        class="me-2"
                        [icon]="icons.incident">
                    </fa-icon>
                }
            }

            <span>{{ activeBanner['bannerDescription' + currentLanguage.toUpperCase()] }}</span>
        </a>
    }

    <!-- Desktop Menu -->
    @if (!isMobile) {
        <div class="container d-flex flex-row justify-content-around">
            <div class="d-flex flex-row justify-content-start w-100">
                <div class="icons-wrapper">
                    <a href="#">
                        <img alt="logo Groupe E" src="../assets/icons/logo_ge.jpg" height="40" width="136">
                    </a>
                    <img class="logo-client" alt="logo client" src="{{env.azureStorageAccountUrl}}/logo/logo_client.jpg"
                         height="50" width="35">
                </div>

                <div class="mt-2">
                    <p>
                        @switch (env.tenantCode) {
                            @case ('dev') {
                                <span>{{ 'menu.clients.softcom' | translate }} - </span>
                            }
                            @case ('qa') {
                                <span>{{ 'menu.clients.softcom' | translate }} - </span>
                            }
                            @case ('cvx') {
                                <span>{{ 'menu.clients.chevroux' | translate }} - </span>
                            }
                            @case ('ccc') {
                                <span>{{ 'menu.clients.cheyres' | translate }} - </span>
                            }
                            @case ('nrz') {
                                <span>{{ 'menu.clients.neyruz' | translate }} - </span>
                            }
                            @case ('clf') {
                                <span>{{ 'menu.clients.leflon' | translate }} - </span>
                            }
                            @case ('vdf') {
                                <span>{{ 'menu.clients.fribourg' | translate }} - </span>
                            }
                            @case ('sem') {
                                <span>{{ 'menu.clients.semsales' | translate }} - </span>
                            }
                            @case ('hrfr') {
                                <span>{{ 'menu.clients.hauterivefr' | translate }} - </span>
                            }
                            @case ('por') {
                                <span>{{ 'menu.clients.portalban' | translate }} - </span>
                            }
                            @case ('demo') {
                                <span>{{ 'menu.clients.demo' | translate }} - </span>
                            }
                            @case ('cvf') {
                                <span>{{ 'menu.clients.villazfr' | translate }} - </span>
                            }
                            @case ('fty') {
                                <span>{{ 'menu.clients.fetigny' | translate }} - </span>
                            }
                            @case ('pdl') {
                                <span>{{ 'menu.clients.lausanne' | translate }} - </span>
                            }
                            @case ('esta') {
                                <span>{{ 'menu.clients.estavayer' | translate }} - </span>
                            }
                            @case ('svz') {
                                <span>{{ 'menu.clients.sevaz' | translate }} - </span>
                            }
                            @case ('cgy') {
                                <span>{{ 'menu.clients.cugyfr' | translate }} - </span>
                            }
                            @case ('lmt') {
                                <span>{{ 'menu.clients.lesmon' | translate }} - </span>
                            }
                            @case ('gsz') {
                                <span>{{ 'menu.clients.rgrecuperation' | translate }} - </span>
                            }
                            @case ('lly') {
                                <span>{{ 'menu.clients.lullyfr' | translate }} - </span>
                            }
                            @case ('cud') {
                                <span>{{ 'menu.clients.cudrefin' | translate }} - </span>
                            }
                            @case ('tlt') {
                                <span>{{ 'menu.clients.latene' | translate }} - </span>
                            }
                            @case ('seod') {
                                <span>{{ 'menu.clients.seod' | translate }} - </span>
                            }
                            @case ('revo') {
                                <span>{{ 'menu.clients.revo' | translate }} - </span>
                            }
                        }
                    <span>{{ 'menu.title' | translate }} {{ envName }} </span>
                    </p>
                </div>
            </div>
            <div class="d-flex flex-row justify-content-end w-100">
                <!-- My Infos - Login/logout -->
                <div class="mt-2 text-end">
                    @if (loggedIn && accountDisplayName) {
                        <button
                            [routerLink]="['users/me']"
                            (click)="toggleMobileMenu()">
                            {{ 'menu.myInfos' | translate }} ({{ accountDisplayName }})
                        </button>
                    }

                    @if (!loggedIn) {
                        <button title="{{'menu.login' | translate}}"
                                (click)="login()" translate>menu.login
                        </button>
                    } @else {
                        <button title="{{'menu.logout' | translate}}"
                                (click)="logout()">{{ 'menu.logout' | translate }}
                            <fa-icon [icon]="icons.signOut"></fa-icon>
                        </button>
                    }
                </div>

                <!-- language settings -->
                <div class="mt-2 text-end">
                    <button (click)="changeLanguage('fr')" [ngClass]='{"active": currentLanguage === "fr"}'>
                        FR
                    </button>

                    @if (isLanguageAvailable('de')) {
                        <button
                            (click)="changeLanguage('de')" [ngClass]='{"active": currentLanguage === "de"}'>
                            DE
                        </button>
                    }

                    @if (isLanguageAvailable('it')) {
                        <button
                            (click)="changeLanguage('it')" [ngClass]='{"active": currentLanguage === "it"}'>
                            IT
                        </button>
                    }

                    @if (isLanguageAvailable('en')) {
                        <button
                            (click)="changeLanguage('en')" [ngClass]='{"active": currentLanguage === "en"}'>
                            EN
                        </button>
                    }
                </div>
            </div>
        </div>
    }

    <!-- Mobile Menu -->
    @if (isMobile) {
        <div class="container d-flex flex-row justify-content-between">
            <div class="icons-wrapper d-flex flex-row justify-content-start">
                <a href="#">
                    <img alt="logo Groupe E" src="../assets/icons/logo_ge.jpg">
                </a>
                <p class="ms-4 text-word-overflow-wrap">
                    @switch (env.tenantCode) {
                        @case ('dev') {
                            <span>{{ 'menu.clients.softcom' | translate }} - </span>
                        }
                        @case ('qa') {
                            <span>{{ 'menu.clients.softcom' | translate }} - </span>
                        }
                        @case ('cvx') {
                            <span>{{ 'menu.clients.chevroux' | translate }} - </span>
                        }
                        @case ('ccc') {
                            <span>{{ 'menu.clients.cheyres' | translate }} - </span>
                        }
                        @case ('nrz') {
                            <span>{{ 'menu.clients.neyruz' | translate }} - </span>
                        }
                        @case ('clf') {
                            <span>{{ 'menu.clients.leflon' | translate }} - </span>
                        }
                        @case ('vdf') {
                            <span>{{ 'menu.clients.fribourg' | translate }} - </span>
                        }
                        @case ('sem') {
                            <span>{{ 'menu.clients.semsales' | translate }} - </span>
                        }
                        @case ('hrfr') {
                            <span>{{ 'menu.clients.hauterivefr' | translate }} - </span>
                        }
                        @case ('por') {
                            <span>{{ 'menu.clients.portalban' | translate }} - </span>
                        }
                        @case ('demo') {
                            <span>{{ 'menu.clients.demo' | translate }} - </span>
                        }
                        @case ('cvf') {
                            <span>{{ 'menu.clients.villazfr' | translate }} - </span>
                        }
                        @case ('fty') {
                            <span>{{ 'menu.clients.fetigny' | translate }} - </span>
                        }
                        @case ('pdl') {
                            <span>{{ 'menu.clients.lausanne' | translate }} - </span>
                        }
                        @case ('esta') {
                            <span>{{ 'menu.clients.estavayer' | translate }} - </span>
                        }
                        @case ('svz') {
                            <span>{{ 'menu.clients.sevaz' | translate }} - </span>
                        }
                        @case ('cgy') {
                            <span>{{ 'menu.clients.cugyfr' | translate }} - </span>
                        }
                        @case ('lmt') {
                            <span>{{ 'menu.clients.lesmon' | translate }} - </span>
                        }
                        @case ('gsz') {
                            <span>{{ 'menu.clients.rgrecuperation' | translate }} - </span>
                        }
                        @case ('lly') {
                            <span>{{ 'menu.clients.lullyfr' | translate }} - </span>
                        }
                        @case ('cud') {
                            <span>{{ 'menu.clients.cudrefin' | translate }} - </span>
                        }
                        @case ('tlt') {
                            <span>{{ 'menu.clients.latene' | translate }} - </span>
                        }
                        @case ('seod') {
                            <span>{{ 'menu.clients.seod' | translate }} - </span>
                        }
                        @case ('revo') {
                            <span>{{ 'menu.clients.revo' | translate }} - </span>
                        }
                    }
                <span>{{ 'menu.title' | translate }} {{ envName }}</span>
                </p>
            </div>

            <!--Burger menu display mobile-->
            <div class="burger-menu">
                <button class="navbar-toggler toggler-example" type="button"
                        [ngClass]='{ "show": isExpanded }'
                        data-toggle="collapse"
                        data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-label="Toggle navigation"
                        (click)="toggleMobileMenu()">
                    <span>
                        {{ (isExpanded ? 'menu.close' : 'menu.open') | translate }}

                        @if (isExpanded) {
                            <fa-icon [icon]="icons.cross"></fa-icon>
                        } @else {
                            <fa-icon [icon]="icons.menu"></fa-icon>
                        }
                    </span>
                </button>
                @if ((isAlarmTriggering || isAlertTriggering || hasUnreadMessage) && !isExpanded) {
                    <span class="dot red dot-mobile-menu"
                          [ngClass]='{"overlaps-over-menu": !isExpanded}'></span>
                }
            </div>
        </div>
    }

    <div class="container main-menu">
        <nav class="navbar navbar-collapse collapse navbar-expand-lg navbar-light"
             [ngClass]='{"show": !isMobile || (isMobile && isExpanded)}'>

            <ng-container id="navbarSupportedContent">

                <!--Main menu-->
                @if (loggedIn) {
                    <div class="nav-menu">
                        <ul class="navbar-nav">
                            @if (customerConfigService.isAlarmsEnabled()) {
                                <li class="nav-item" [appHasAnyPermission]="[PermissionKeys.gestionAlertesAlarmes, PermissionKeys.configurationAlertesAlarmes]">
                                    <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                        <a class="nav-link max-width" href="#" [routerLink]="['alarms']"
                                           routerLinkActive
                                           #alarmsLink="routerLinkActive"
                                           [ngClass]='{"selected": alarmsLink.isActive}'>
                                            <span translate="menu.navigation.alarms.main">
                                                @if (isAlarmTriggering) {
                                                    <fa-icon [icon]="icons.alertNotification"
                                                             class="alert-notification-bell"></fa-icon>
                                                }
                                            </span>

                                            @if (isMobile) {
                                                <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                            }
                                        </a>
                                    </div>
                                </li>
                            }

                            @if (customerConfigService.isAlarmsEnabled()) {
                                <li class="nav-item" [appHasAnyPermission]="[PermissionKeys.gestionAlertesAlarmes, PermissionKeys.configurationAlertesAlarmes]">
                                    <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                        <a class="nav-link max-width" href="#" [routerLink]="['alerts']"
                                           routerLinkActive
                                           #alertsLink="routerLinkActive"
                                           [ngClass]='{"selected": alertsLink.isActive}'>
                                            <span translate="menu.navigation.alerts.main">
                                                @if (isAlertTriggering) {
                                                    <fa-icon [icon]="icons.alertNotification"
                                                             class="alert-notification-bell"></fa-icon>
                                                }
                                            </span>
                                            @if (isMobile) {
                                                <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                            }
                                        </a>
                                    </div>
                                </li>
                            }

                            <li class="nav-item" [appHasAnyPermission]="[PermissionKeys.gestionClients, PermissionKeys.gestionBackoffices]">
                                <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                    <a class="nav-link max-width" href="#" [routerLink]="['users']"
                                       routerLinkActive
                                       #userLink="routerLinkActive"
                                       [ngClass]='{"selected": userLink.isActive}'>
                                        <span translate="menu.navigation.users"></span>
                                        @if (isMobile) {
                                            <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                        }
                                    </a>
                                </div>
                            </li>

                            <li class="nav-item">
                                <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                    <a class="nav-link max-width" href="#" [routerLink]="['services']"
                                       routerLinkActive
                                       #serviceLink="routerLinkActive"
                                       [ngClass]='{"selected": serviceLink.isActive}'>
                                        <span translate="menu.navigation.services"></span>
                                        @if (isMobile) {
                                            <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                        }
                                    </a>
                                </div>
                            </li>

                            @if (customerConfigService.isEwalletEnabled()) {
                                <li class="nav-item" [appHasAnyRole]="[AppRoles.customer]">
                                    <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                        <a class="nav-link max-width" href="#" [routerLink]="['ewallet']"
                                           routerLinkActive
                                           #walletLink="routerLinkActive"
                                           [ngClass]='{"selected": walletLink.isActive}'>
                                            <span translate="menu.navigation.wallet"></span>
                                            @if (isMobile) {
                                                <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                            }
                                        </a>
                                    </div>
                                </li>
                            }

                            <li class="nav-item" [appHasAnyPermission]="[PermissionKeys.gestionTransactions]">
                                <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                    <a class="nav-link max-width" href="#" [routerLink]="['ewallets']"
                                       routerLinkActive
                                       #ewalletsLink="routerLinkActive"
                                       [ngClass]='{"selected": ewalletsLink.isActive}'>
                                        <span translate="menu.navigation.wallets"></span>
                                        @if (isMobile) {
                                            <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                        }
                                    </a>
                                </div>
                            </li>

                            @if (customerConfigService.isEwalletEnabled() && canAccessTransactionsMenu()) {
                                <li class="nav-item">
                                    <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                        <a class="nav-link max-width" href="#" [routerLink]="getTransactionRootRoute()"
                                           routerLinkActive
                                           #transactionsLink="routerLinkActive"
                                           [ngClass]='{"selected": transactionsLink.isActive}'>
                                            <span translate="menu.navigation.transactions.main"></span>
                                            @if (isMobile) {
                                                <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                            }
                                        </a>
                                    </div>
                                </li>
                            }

                            <li class="nav-item" [appHasAnyPermission]="[PermissionKeys.gestionCartes]">
                                <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                    <a class="nav-link max-width" href="#" [routerLink]="['cards']"
                                       routerLinkActive
                                       #rfidCardsLink="routerLinkActive"
                                       [ngClass]='{"selected": rfidCardsLink.isActive}'>
                                        <span translate="menu.navigation.cards"></span>
                                        @if (isMobile) {
                                            <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                        }
                                    </a>
                                </div>
                            </li>

                            @if (customerConfigService.isAlarmsEnabled() || customerConfigService.isInfrastructureEnabled()) {
                                <li class="nav-item"
                                    [appHasAnyPermission]="[PermissionKeys.gestionInfrastructure]">
                                    <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                        <a class="nav-link max-width" href="#" [routerLink]="['infrastructure']"
                                           routerLinkActive
                                           #insfrastructureLink="routerLinkActive"
                                           [ngClass]='{"selected": insfrastructureLink.isActive}'>
                                            <span translate="menu.navigation.infrastructure.main"></span>
                                            @if (isMobile) {
                                                <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                            }
                                        </a>
                                    </div>
                                </li>
                            }

                            @if (communicationChannelConfigService.isCommunicationChannelEnabled() && loggedIn && canAccessCommunicationMenu()) {
                                <li class="nav-item">
                                    <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                        <a class="nav-link max-width" href="#" [routerLink]="['communication-channel']"
                                           routerLinkActive
                                           #communicationChannel="routerLinkActive"
                                           [ngClass]='{"selected": communicationChannel.isActive}'>
                                            <span translate="menu.navigation.communicationChannel.main">
                                                @if (hasUnreadMessage) {
                                                    <fa-icon [icon]="icons.alertNotification"
                                                             class="alert-notification-bell"></fa-icon>
                                                }
                                            </span>

                                            @if (isMobile) {
                                                <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                            }
                                        </a>
                                    </div>
                                </li>
                            }

                            <li class="nav-item" [appHasAnyRole]="[AppRoles.backoffice]">
                                <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                    <a class="nav-link max-width" href="#" [routerLink]="['statistics']"
                                       routerLinkActive
                                       #statisticsLink="routerLinkActive"
                                       [ngClass]='{"selected": statisticsLink.isActive}'>
                                        <span translate="menu.navigation.statistics"></span>
                                        @if (isMobile) {
                                            <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                        }
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                }

                <!-- Visitor Menu -->
                @if (!loggedIn) {
                    <div class="nav-menu">
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <div class="menu" (click)="toggleMobileMenu()" (keyup)="toggleMobileMenu()">
                                    <a class="nav-link max-width" href="#"
                                       [routerLink]="['services']"
                                       routerLinkActive
                                       #serviceLink="routerLinkActive"
                                       [ngClass]='{"selected": serviceLink.isActive}'>
                                        <span translate="menu.navigation.services"></span>
                                        @if (isMobile) {
                                            <fa-icon [icon]="icons.chevronRight" class="chevron-right"></fa-icon>
                                        }
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </div>
                }
            </ng-container>

            @if (isMobile) {
                <div class="secondary-menu mobile"
                     [ngClass]='{ "logged-in-upper-menu": loggedIn }'>
                    <!-- My Infos - Login/logout -->
                    <div class="login-info">
                        @if (loggedIn && accountDisplayName) {
                            <button class="my-info"
                                    [routerLink]="['users/me']"
                                    (click)="toggleMobileMenu()">
                                {{ 'menu.myInfos' | translate }} ({{ accountDisplayName }})
                            </button>
                        }

                        @if (!loggedIn) {
                            <button title="{{'menu.login' | translate}}"
                                    (click)="login()" translate>menu.login
                            </button>
                        } @else {
                            <button title="{{'menu.logout' | translate}}"
                                    (click)="logout()">{{ 'menu.logout' | translate }}
                                <fa-icon [icon]="icons.signOut"></fa-icon>
                            </button>
                        }
                    </div>

                    <!-- language settings -->
                    <div class="language-settings">
                        <button (click)="changeLanguage('fr')" [ngClass]='{"active": currentLanguage === "fr"}'>
                            FR
                        </button>
                        @if (isLanguageAvailable('de')) {
                            <button
                                (click)="changeLanguage('de')" [ngClass]='{"active": currentLanguage === "de"}'>
                                DE
                            </button>
                        }
                        @if (isLanguageAvailable('it')) {
                            <button
                                (click)="changeLanguage('it')" [ngClass]='{"active": currentLanguage === "it"}'>
                                IT
                            </button>
                        }
                        @if (isLanguageAvailable('en')) {
                            <button
                                (click)="changeLanguage('en')" [ngClass]='{"active": currentLanguage === "en"}'>
                                EN
                            </button>
                        }
                    </div>
                </div>
            }
        </nav>
    </div>
</div>

<div class="main-container container">
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    @if (!isIframe) {
        <router-outlet></router-outlet>
        <app-application-loader></app-application-loader>
    }
</div>

<div class="footer container">
    <a href="#"
       [routerLink]="['cgv']" translate>{{ 'common.cgv' }}</a>

    <a href="#"
       [routerLink]="['cgu']" translate>{{ 'common.cgu' }}</a>

    @if (loggedIn) {
        <a href="#"
           [routerLink]="['forgetme']" translate>{{ 'common.erasureRight' }}</a>
    }

    <a href="javascript:void(0);" translate
       (click)="downloadInstructionsManual()">{{ 'common.instructionsManual' }}</a>
</div>

<ng-template appConfirmModal>
    <app-confirm-modal></app-confirm-modal>
</ng-template>
